<template>
  <thead class="item sort">
    <th v-for="item in 4" :key="item">
      <v-skeleton-loader type="text" />
    </th>
  </thead>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
thead {
  max-width: 100%;
  th {
    border-bottom: 1px solid map-get($gray, lighten2);

    height: 52px;
    &:first-child {
      .v-skeleton-loader {
        margin-left: 8px;
      }
    }

    &:nth-child(1) {
      width: 566px;
    }
    &:nth-child(2) {
      width: 177px;
    }
    &:nth-child(3) {
      width: 436px;
    }
    &:nth-child(4) {
      width: 147px;
    }
    &:last-child {
      > div{
        margin-left: auto;
      }
    }
    padding: 6px 16px;
    .v-skeleton-loader {
      max-width: 62px;
    }
  }
}
</style>